<div class="form-bloque-info-person" [formGroup]="form">
    <div class="text-uppercase text-secondary mb-2 fw-semibold small">Datos personales</div>
    <div class="form-items d-flex flex-column gap-1">
        <div class="row g-1">
            <div class="col-12 col-md-6">
                <div class="form-floating">
                    <input type="text" class="form-control focus-ring focus-ring-light" id="personFirstName"
                        placeholder=" " formControlName="name" maxlength="40"
                        [class.is-invalid]="form.get('name')?.touched && form.get('name')?.invalid">
                    <label for="personFirstName">Nombres</label>
                    <div class="invalid-feedback">El campo nombres es obligatorio.</div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-floating">
                    <input type="text" class="form-control focus-ring focus-ring-light" id="personLastName"
                        placeholder=" " formControlName="lastName" maxlength="40"
                        [class.is-invalid]="form.get('lastName')?.touched && form.get('lastName')?.invalid">
                    <label for="personLastName">Apellidos</label>
                    <div class="invalid-feedback">El campo apellidos es obligatorio.</div>
                </div>
            </div>
        </div>
        <div class="row g-1">
            <div class="col-12 col-md-6">
                <div class="form-floating">
                    <select class="form-select focus-ring focus-ring-light" id="personDocumentType"
                        aria-label="Tipo de documento" formControlName="documentType"
                        [class.is-invalid]="form.get('documentType')?.touched && form.get('documentType')?.invalid">
                        <option [ngValue]="null" disabled selected>Selecciona una opción</option>
                        <option [ngValue]="'IdCard'">Cédula</option>
                        <option [ngValue]="'Passport'">Pasaporte</option>
                    </select>
                    <label for="personDocumentType">Tipo de documento</label>
                    <div class="invalid-feedback">Debe seleccionar un tipo de documento.</div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-floating">
                    <input type="text" class="form-control focus-ring focus-ring-light" id="personDocumentNumber"
                        placeholder=" " formControlName="documentNumber" [mask]="documentMask"
                        [class.is-invalid]="form.get('documentNumber')?.touched && form.get('documentNumber')?.invalid">
                    <label for="personDocumentNumber">{{ idLabel }}</label>
                    <div class="invalid-feedback">
                        @if (form.get('documentNumber')?.hasError('passportLength')) {
                        El pasaporte debe tener entre 5 y 12 caracteres.
                        } @else {
                        El campo número de documento es obligatorio.
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="row g-1">
            <div class="col-12 col-md-6">
                <label class="form-label" for="personDocumentExpiry">Fecha de vencimiento documento</label>
                <app-datepicker-input id="personDocumentExpiry" formControlName="documentExpiresAt"
                    [control]="form.get('documentExpiresAt')" inputClass="form-control focus-ring focus-ring-light"
                    [placeholder]="isPassport ? 'dd/mm/aaaa' : 'No aplica'"
                    [minDate]="isPassport ? today : null" [maxDate]="isPassport ? passportExpiryMax : null"
                    [errorMessages]="{
                      expiresBeforeBirth: 'Debe ser mayor a la fecha de nacimiento.',
                      required: 'La fecha de vencimiento del pasaporte es obligatoria.',
                      expired: 'El pasaporte está vencido.',
                      maxDate: 'La fecha no puede ser posterior al ' + passportExpiryMaxDisplay + '.'
                    }"></app-datepicker-input>
                @if (!isPassport) {
                <div class="form-text">Solo aplica para pasaporte.</div>
                }
            </div>
            <div class="col-12 col-md-6">
                <label class="form-label" for="personBirthDate">Fecha de nacimiento</label>
                <app-datepicker-input id="personBirthDate" formControlName="birthDate" [control]="form.get('birthDate')"
                    [inputClass]="'form-control focus-ring focus-ring-light' + (readonlyBirthDate ? ' readonly bg-light' : '')"
                    [readonly]="readonlyBirthDate" [errorMessages]="{
                      required: 'La fecha de nacimiento es obligatoria.'
                    }"></app-datepicker-input>
            </div>
        </div>
        <div class="row g-1">
            <div class="col-12 col-md-6">
                <div class="form-floating">
                    <select class="form-select focus-ring focus-ring-light" id="personMaritalStatus"
                        aria-label="Estado civil" formControlName="civilState"
                        [class.is-invalid]="form.get('civilState')?.touched && form.get('civilState')?.invalid">
                        <option [ngValue]="null" disabled selected>Selecciona una opción</option>
                        <option [ngValue]="'Single'">Soltero/a</option>
                        <option [ngValue]="'Married'">Casado/a</option>
                    </select>
                    <label for="personMaritalStatus">Estado civil</label>
                    <div class="invalid-feedback">Debe seleccionar un estado civil.</div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-floating">
                    <select class="form-select focus-ring focus-ring-light" id="personGender" aria-label="Sexo"
                        formControlName="gender" [class.bg-light]="readonlyGender" [class.readonly]="readonlyGender"
                        [class.is-invalid]="form.get('gender')?.touched && form.get('gender')?.invalid">
                        <option value="" disabled>Seleccione</option>
                        <option value="F">Femenino</option>
                        <option value="M">Masculino</option>
                    </select>
                    <label for="personGender">Sexo</label>
                    <div class="invalid-feedback">Debe seleccionar el sexo.</div>
                </div>
            </div>
        </div>
        <div class="row g-1">
            <div class="col-12 col-md-4">
                <div class="form-floating">
                    <input type="text" class="form-control focus-ring focus-ring-light" id="personHeightFeet"
                        placeholder=" " formControlName="heightFeet" inputmode="numeric" maxlength="2"
                        [class.is-invalid]="form.get('heightFeet')?.touched && form.get('heightFeet')?.invalid">
                    <label for="personHeightFeet">Pies</label>
                    <div class="invalid-feedback">Ingrese pies válidos.</div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-floating">
                    <input type="text" class="form-control focus-ring focus-ring-light" id="personHeightInches"
                        placeholder=" " formControlName="heightInches" inputmode="numeric" maxlength="2"
                        [class.is-invalid]="form.get('heightInches')?.touched && form.get('heightInches')?.invalid">
                    <label for="personHeightInches">Pulgadas</label>
                    <div class="invalid-feedback">
                        @if (form.get('heightInches')?.hasError('max')) {
                        Las pulgadas no pueden ser mayores a 11.
                        } @else {
                        Ingrese pulgadas válidas.
                        }
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-floating">
                    <input type="text" class="form-control focus-ring focus-ring-light" id="personWeight"
                        placeholder=" " formControlName="weightDisplay" mask="000"
                        [class.is-invalid]="form.get('weightDisplay')?.touched && (form.get('weightDisplay')?.invalid || form.get('weightLb')?.invalid)">
                    <label for="personWeight">Peso</label>
                    <div class="invalid-feedback">El peso debe ser mayor al introducido.</div>
                </div>
                <div class="d-flex gap-3 mt-1">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input focus-ring focus-ring-light" type="radio"
                            formControlName="weightUnit" id="personWeightUnitKg" value="kg">
                        <label class="form-check-label" for="personWeightUnitKg">Kg</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input focus-ring focus-ring-light" type="radio"
                            formControlName="weightUnit" id="personWeightUnitLb" value="lb">
                        <label class="form-check-label" for="personWeightUnitLb">Lb</label>
                    </div>
                </div>
            </div>
            @if (bmiExceedsMax) {
            <div class="col-12">
                <div class="text-danger small mt-1">
                    El Índice de Masa Corporal (IMC: {{ bmiValue | number: '1.1-1' }}) supera el máximo permitido. No es
                    posible continuar con esta solicitud.
                </div>
            </div>
            }
        </div>
        <div class="row g-1">
            <div class="col-12">
                <div class="form-floating">
                    <select class="form-select focus-ring focus-ring-light" id="personNationality"
                        aria-label="Nacionalidad" formControlName="nacionality"
                        [class.is-invalid]="form.get('nacionality')?.touched && form.get('nacionality')?.invalid">
                        <option [ngValue]="null" disabled selected>Selecciona una opción</option>
                        <option [ngValue]="'Dominican'">Dominicano/a</option>
                        <option [ngValue]="'Foreign'">Extranjero/a</option>
                    </select>
                    <label for="personNationality">Nacionalidad</label>
                    <div class="invalid-feedback">Debe seleccionar la nacionalidad.</div>
                </div>
            </div>
        </div>

        <div class="row g-1 mt-2">
            <div class="col-12">
                <div class="d-flex align-items-center gap-2">
                    <label class="form-check-label">
                        ¿Es una Persona Expuesta Políticamente (PEP)?
                    </label>
                    <button #infoButton type="button"
                        class="btn btn-sm p-0 btn-outline-light text-muted border-0 rounded-circle"
                        data-bs-toggle="popover" data-bs-placement="top" data-bs-custom-class="custom-popover"
                        data-info-title="¿Es una Persona Expuesta Políticamente (PEP)?"
                        data-info-content="Persona que desempeña o ha desempeñado, durante los últimos tres (3) años altas funciones públicas, por elección o nombramientos ejecutivos, en un país extranjero o en territorio nacional, incluyendo altos funcionarios de organizaciones internacionales. Incluye, funcionarios gubernamentales, judiciales o militares de alta jerarquía, así como funcionarios de gobiernos extranjeros."
                        aria-label="Más información sobre PEP" (click)="onInfoClick($event)">
                        <app-icon name="info" [size]="20" [strokeWidth]="2" color="#9e9e9e"></app-icon>
                    </button>
                </div>
                <div class="d-flex align-items-center gap-4 mt-2">
                    <div class="form-check">
                        <input class="form-check-input focus-ring focus-ring-light" type="radio" id="personIsPepYes"
                            formControlName="isPep" [value]="true">
                        <label class="form-check-label" for="personIsPepYes">Si</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input focus-ring focus-ring-light" type="radio" id="personIsPepNo"
                            formControlName="isPep" [value]="false">
                        <label class="form-check-label" for="personIsPepNo">No</label>
                    </div>
                </div>
                @if (form.get('isPep')?.hasError('required') && form.get('isPep')?.touched) {
                <div class="text-danger small mt-1">Este campo es requerido</div>
                }
            </div>
        </div>
    </div>
</div>